import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BaseComponent } from './base.component';

@Component({ template: '' })
export class BaseStepComponent extends BaseComponent implements OnInit {
    // tslint:disable-next-line: no-input-rename
    @Input('form') cadastro: FormGroup;
    @Input() acao = '';


}



// WEBPACK FOOTER //
// ./src/app/base/base-step.component.ts